export default () => ({
    user: {}
  })